module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDkYbFIAAAAEHRSTlMA7yAQv6/fgEBQcDCPz2CfGQTH8wAAAMNJREFUeF7t1dGRgzAQBNHRrhAYMKf8o70EmLPbX1flfRlMVa+k/6eUUmJMaITurBNbdeea2EN3Ek/rurdNpoWMZSKXnGwTWOQ9yLCUAcdtMuC4U3/b53ueqRf6fMuhV6Kx2/B2mLTXWdJewKS9FSbtPVnS3sGTFh93ihg+aSEbTNo7zbBdUA6QNB/XQtyP+X6wbChp8oCP1GcWkDQZd+pjl0ma6yZpLJpJGttN0lw3SWNhkuZWnzS/uZ4ykDj0jUop5Rev60NZI0iJ+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f53b.png
// module id = 1134
// module chunks = 0